import { Alert, Button, Card, Modal, Space } from "antd";
import {
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useKycQuestionnaireSend } from "./useKycQuestionnaireSend";
import { useKycQuestionnaireDetail } from "./useKycQuestionnaireDetail";

export const KycQuestionnaireSendWidget = ({ _id }: { _id: string }) => {
  const { data: questionnaire } = useKycQuestionnaireDetail({ _id });
  const {
    loading,
    unrespondedCount,
    refreshUnrespondedCount,
    sendToAllUnresponded,
  } = useKycQuestionnaireSend({ questionnaireId: _id });

  useEffect(() => {
    refreshUnrespondedCount();
  }, [refreshUnrespondedCount]);

  return (
    <>
      <div className="page-header">
        <h3>KYC Судалгаа илгээх: {questionnaire?.name ?? ""}</h3>
        <Link to={`/kyc-questionnaires/detail/${_id}`}>
          <Button type="dashed" icon={<ArrowLeftOutlined />}>
            Буцах
          </Button>
        </Link>
      </div>

      {questionnaire && !questionnaire.active && (
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 12 }}
          message="Энэ KYC судалгаа Идэвхгүй байна"
          description="Идэвхтэй болгосны дараа илгээх боломжтой."
        />
      )}

      <Card title="Бөглөөгүй бүх хэрэглэгчид илгээх" size="small">
        <Space>
          <span>
            Илгээх боломжтой:&nbsp;
            <strong>{unrespondedCount ?? "—"}</strong>&nbsp;хэрэглэгч
          </span>
          <Button
            type="primary"
            icon={<SendOutlined />}
            loading={loading}
            disabled={!unrespondedCount || !questionnaire?.active}
            onClick={() => {
              Modal.confirm({
                title: "Бүх бөглөөгүй хэрэглэгчдэд илгээх үү?",
                icon: <ExclamationCircleOutlined />,
                content: `${unrespondedCount} хэрэглэгчид илгээх гэж байна. Үргэлжлүүлэх үү?`,
                okText: "Илгээх",
                cancelText: "Болих",
                onOk: () => sendToAllUnresponded(),
              });
            }}
          >
            Бүгдэд илгээх ({unrespondedCount ?? 0})
          </Button>
        </Space>
      </Card>
    </>
  );
};
